<template>
	<div class="">
		<!-- <button class="btn" v-on:click="schedule.open = true">On</button>
		<button class="btn" v-on:click="schedule.open = false">Off</button> -->

		<timed-content
				:from="new Date(checkDay.openDate + ' ' + schedule.openTime)"
				:to="new Date(checkDay.openDate + ' ' + schedule.closeTime)"
				time-zone="America/Los_Angeles">
				
			
		<div class="container center" v-if="schedule.open == true"><!--{{schedule.openDate}}-->
			<div class="row" v-if="settings.homepage_alert">
				<p class="col-md-12 alert-info border-info alert" >
					<span v-html="settings.homepage_alert"></span>
					
				</p>
			</div>
			<div class="d-inline-block option" v-if="queues">
				<h1 class="title-prompt">I'm here for</h1>  <!-- {{checkDay.openDate}} -->
			</div>
			<div class="row" v-if="settings.homepage_help">
				<p class="col-md-12" >
					<span v-html="settings.homepage_help"></span>
				</p>
			</div>
			<div class="queue-selector">
				<div class="d-inline-block option" v-for='q in queues' :key="q.Id">
					<div :id="q.Id"><router-link class="queue-link btn btn-primary btn-lg w-100" :to="'/queue/'+q.Id">{{q.DisplayName}}</router-link>
				</div>
			</div>
		</div><br />
	</div> </timed-content>

		<!-- <div class="container closed-container center"> -->
		<div class="container closed-container center" v-if="schedule.open == true">
			<div class="row" v-if="settings.homepage_alert">
				<p class="col-md-12 alert-info border-info alert" >
					<span v-html="settings.homepage_alert"></span>
				</p>
			</div>

			
			
			<div v-if="settings.homepage_message"></div><h1 class="title-prompt">This office<br />is closed</h1>
			<!-- {{ schedule.startDateTime }} {{schedule.openDate}} {{ schedule.closeTime }}{{checkDay.openDate}} -->
			
			<p class="away-message">Please visit uw.edu/our or return during office hours</p>
			<!-- <p class="away-message">Please visit uw.edu/osfa or return during office hours</p> -->
			<!-- <p class="away-message">Please visit uw.edu/veterans or return during office hours</p> -->
			</div>
			<div class="row" v-if="settings.homepage_help">
				<p class="col-md-12" >
					<span v-html="settings.homepage_help"></span>
				</p>
			</div>
			<!-- <div class="queue-selector">
				<div class="d-inline-block option" v-for='q in queues' :key="q.Id">
					<div class="queue-link btn btn-primary btn-lg w-100" :to="'/queue/'+q.Id">{{q.DisplayName}}</div>
				</div>
			</div>
		</div> -->
	</div>
</template>

<script>
import { EventBus } from '../event-bus.js';
import TimedContent from "vue-timed-content";
import moment from 'moment';
export default {
    components: { TimedContent },
	name: 'ChoosePath',
	props: [
		'socket', 
		'api_root'
	],
	data () {
		return {
			loading: false,
			reservation: {
				name: "",
				question: ""
			},
			settings: {
				homepage_alert: null,
				homepage_help: null
			},
			schedule: {
				startDateTime: moment(new Date()).format('dddd'),
				endDateTime: null,
				open: true,
				status: false,
				openTime: "09:45:00",
				// openTime: "11:15:00",
				closeTime: "15:59:59",
				openDate: "",
				// openDate: moment(new Date()).format('YYYY/MM/DD'),
			},
			checkDay: {
				openDate: self.openDate = moment(new Date()).format('YYYY/MM/DD')
			},
			queues: null
		}
	},		
	mounted: function () {
		let self = this;
		self.getQueues();
		self.getSchedule();
		self.getSetting('homepage_alert');
		self.getSetting('homepage_help');
		self.getCheckDay('openDate');
		self.moment = moment;
	},
	methods: {
		addRegistration: function () {
			console.log('addRegistration');
			// let data = {name:'register', payload: this.reservation};
			// EventBus.$emit('publish', data);
		},
		getQueues: function () {
			this.loading = true;
			var self = this;

			fetch(self.api_root + 'queuess/?Active=1&Retired=0', {
				method: "GET",
				headers: {
					'Access-Control-Allow-Origin': '*',
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Cache': 'no-cache'
				},
				credentials: "omit"
			})
			.then(function (response) {
				return response.json();
			})
			.then(function (response) {
				if (response) {
					if (typeof response.data !== 'undefined') {
						self.queues = response.data.sort(function(a, b) {return a.OrderNum > b.OrderNum});
						console.log(self.queues);
					}
				} else {
					console.log(self.error, response.error);
					self.error = response.error;
				}
				self.loading = false;
			})
			.catch(function (error) {
				// window.eventBus.$emit('fetchError', error);
				EventBus.$emit('fetchError', error);
			});
		}, 
		getSchedule: function (name) {
			var self = this;

			var url = self.api_root + 'schedules/?Active=1'
			console.log('getSchedule', url);
			fetch(url, {
				method: "GET",
				headers: {
					'Access-Control-Allow-Origin': '*',
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Cache': 'no-cache'
				},
				credentials: "omit"
			})
			.then(function (response) {
				return response.json();
			})
			.then(function (response) {
				if (response) {
					if (typeof response.data !== 'undefined') {
						console.log(response.data);
						self.schedule[name] = response.data[0].Value;
						console.log(name, self.schedule[name], response.data[0].Value);
					}
				} else {
					console.log(self.error, response.error);
					self.error = response.error;
				}
				self.loading = false;
			})
			.catch(function (error) {
				EventBus.$emit('fetchError', error);
				// window.eventBus.$emit('fetchError', error);
			});
			
		},
		getSetting: function (name) {
			var self = this;

			var url = self.api_root + 'settingss/?Name=' + name;
			console.log('getSetting', url);
			fetch(url, {
				method: "GET",
				headers: {
					'Access-Control-Allow-Origin': '*',
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Cache': 'no-cache'
				},
				credentials: "omit"
			})
			.then(function (response) {
				return response.json();
			})
			.then(function (response) {
				if (response) {
					if (typeof response.data !== 'undefined') {
						console.log(response.data);
						self.settings[name] = response.data[0].Value;
						console.log(name, self.settings[name], response.data[0].Value);
					}
				} else {
					console.log(self.error, response.error);
					self.error = response.error;
				}
				self.loading = false;
			})
			.catch(function (error) {
				EventBus.$emit('fetchError', error);
				// window.eventBus.$emit('fetchError', error);
			});
		},
		toTime(date) {
			return new Date(date).toLocaleString()
		},
		getCheckDay: function() {
			var self = this;

			self.openDate = "self.openDate = moment(new Date()).format('YYYY/MM/DD')";
			// self.openDate = "2023/11/28";

			// if (self.schedule.mon == true && moment(new Date()).format('dddd') == "Monday") {
			// 	self.openDate = moment(new Date()).format('YYYY/MM/DD');
			// }
			// else if (self.schedule.tue == true && moment(new Date()).format('dddd') == "Tuesday") {
			// 	self.openDate = moment(new Date()).format('YYYY/MM/DD');
			// }
			// else if (self.schedule.wed == true && moment(new Date()).format('dddd') == "Wednesday") {
			// 	self.openDate = moment(new Date()).format('YYYY/MM/DD');
			// }
			// else if (self.schedule.thu == true && moment(new Date()).format('dddd') == "Thursday") {
			// 	self.openDate = moment(new Date()).format('YYYY/MM/DD');
			// }
			// else if (self.schedule.fri == true && moment(new Date()).format('dddd') == "Friday") {
			// 	self.openDate = moment(new Date()).format('YYYY/MM/DD');
			// }
			return self.openDate;
		}

	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.queue-link {
		margin-top:1rem;
	}

	.title-prompt {
		margin-bottom:1rem;
		margin-top:1rem;
		font-weight:300;font-size:64pt;
	}

	.queue-selector {
		column-count:2;

	}

	.option {
		width:100%;
	}

	#app .queue-buttons .btn {
		height:5rem;
		width:100%;
		/* border-radius:.5rem; */
		line-height:4rem;
		/* font-size:20px; */
	}
</style>